import React from 'react'
import { TraceHierarchy } from '../domain/Trace'
import { TraceSummary } from '../domain/TraceSummary'
import HierarchicalTraceTable from '../monitor/hierarchical_trace_table'
import { Box, BoxBody } from '../ui/box'
import { Col, Row } from '../ui/grid'

interface OwnProps {
    traceHierarchy?: TraceHierarchy
    currentTraceId: string
}

export interface TraceItem {
    trace: TraceSummary
    depth: number
}

type Props = OwnProps

class RelatedTraces extends React.Component<Props, {}> {
    public render() {
        return this.props.traceHierarchy ? (
            <Row>
                <Col>
                    <Box>
                        <BoxBody>
                            <HierarchicalTraceTable traces={this.props.traceHierarchy} currentTraceId={this.props.currentTraceId} />
                        </BoxBody>
                    </Box>
                </Col>
            </Row>
        ) : null
    }
}

export default RelatedTraces
